let playedVideoPagePromise;

const preloadPlayedVideoPage = () => {
  if (!playedVideoPagePromise) {
    playedVideoPagePromise = import("./PlayedVideo");
  }

  return playedVideoPagePromise;
};

export { preloadPlayedVideoPage };
